import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { HelpMessage } from './help-message.model';

@Injectable()
export class HelpMessageService {

  constructor(private http: HttpClient) { }


}
